/** Enum ролей в приложении */
export enum PositionRoles {
  ADMIN = 'admin',
  MANAGER = 'manager',
  PARTNER = 'partner'
}
